import { useMemo } from 'react';
import { useHits } from 'react-instantsearch';
import { FormattedMessage } from 'react-intl';

import { LabelM } from '@sorare/core/src/atoms/typography';
import { useIntlContext } from '@sorare/core/src/contexts/intl';

export const TotalResults = () => {
  const { formatNumber } = useIntlContext();
  const { results } = useHits();
  const roundingIncrement = useMemo(() => {
    if (!results?.nbHits) return 1;
    if (results.nbHits > 10000) return 10000;
    if (results.nbHits > 1000) return 1000;
    if (results.nbHits > 100) return 100;
    return 1;
  }, [results?.nbHits]);

  if (!results) return null;

  const total =
    Math.floor(results.nbHits / roundingIncrement) * roundingIncrement;

  return (
    <LabelM color="var(--c-neutral-600)">
      <FormattedMessage
        id="searchCards.totalResults"
        defaultMessage="{formattedTotal}{plus} {total, plural, one {result} other {results}}"
        values={{
          total,
          formattedTotal: formatNumber(
            Math.floor(results.nbHits / roundingIncrement) * roundingIncrement,
            {
              roundingMode: 'trunc',
            }
          ),
          plus: roundingIncrement !== 1 ? '+' : '',
        }}
      />
    </LabelM>
  );
};
